import {
  params, string, shape, bool, client, arrayOf, extend, number
} from '@thd-nucleus/data-sources';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { Price } from '@thd-olt-component-react/price';
import { SuperSku, SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { Promotion } from '@thd-olt-component-react/promotion';

const installServices = shape({
  scheduleAMeasure: bool()
});
if (installServices.skip) {
  installServices.skip('skipInstallServices', true);
}

export const dataModel = extend({
  product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
    itemId: string(),
    availabilityType: shape({
      discontinued: bool(),
      type: string()
    }),
    badges: params({ storeId: string() }).arrayOf(shape({
      name: string(),
    })),
    details: shape({
      collection: shape({
        collectionId: string(),
        name: string(),
        url: string(),
      })
    }),
    favoriteDetail: client(shape({
      count: number()
    })),
    fulfillment: client(params({ storeId: string() }).shape({
      fulfillmentOptions: arrayOf(shape({
        type: string(),
        fulfillable: bool(),
        services: arrayOf(shape({
          type: string(),
          locations: arrayOf(shape({
            inventory: shape({
              isInStock: bool(),
              isLimitedQuantity: bool()
            })
          }))
        }))
      }))
    })),
    identifiers: shape({
      brandName: string(),
      canonicalUrl: string(),
      modelNumber: string(),
      productType: string(),
      productLabel: string(),
      itemId: string()
    }),
    info: shape({
      isBuryProduct: bool(),
      isSponsored: bool(),
      isGenericProduct: bool(),
      isLiveGoodsProduct: bool(),
      sponsoredBeacon: shape({
        onClickBeacon: string(),
      }),
      globalCustomConfigurator: shape({
        customExperience: string()
      }),
      returnable: bool(),
    }),
    installServices,
    media: shape({
      image: shape({
        url: string()
      }),
      images: arrayOf(shape({
        url: string(),
        type: string(),
        subType: string(),
        sizes: arrayOf(string())
      }))
    }),
    reviews: shape({
      ratingsReviews: shape({
        averageRating: string(),
        totalReviews: string(),
      })
    })
  })
},
Favorite,
KeyProductFeatures,
FulfillmentPodStore,
FulfillmentPodShipping,
Price,
SuperSkuMiniSwatches,
SuperSku,
Promotion,
);
